import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import {
  actions,
  selectors,
} from '../../store/dux/field-boundary-management-dux';
import Confirmation from './UncertifyConfirmation';
import Results from './ValidationResults';

export function UncertifyFields(props) {
  const dispatch = useDispatch();
  const results = useSelector(selectors.uncertificationResults);

  useEffect(() => {
    dispatch(actions.clearResults());
  }, [dispatch]);

  return results ? (
    <Results
      validationResults={results}
      handleClose={props.close}
      dialogMode="UNCERTIFY"
    />
  ) : (
    <Confirmation
      fields={props.fields}
      handleClose={props.close}
      handleUncertified={handleCertified}
    />
  );

  async function handleCertified(uncertifyResults) {
    dispatch(actions.fieldsUncertified(uncertifyResults));
  }
}
